import { opaqueCursorSchema as e, pageLimitSchema as t, uuidSchema as n } from "../common/index.js";
import { incidentInstantSchema as r, incidentPrioritySchema as i, incidentSummarySchema as a, incidentVersionSchema as o } from "../incidents/incidents.schema.js";
import "../incidents/index.js";
import { z as s } from "zod";
// src/webhooks/webhooks.schema.ts
function c(e) {
	return s.string().refine((t) => t.isWellFormed() && !t.includes("\0") && t.trim().length > 0 && [...t].length <= e, `Text must be nonblank and at most ${e} Unicode code points.`);
}
var l = s.enum([
	"checkly",
	"datadog",
	"grafana",
	"prtg"
]), u = s.enum([
	"disabled",
	"enabled",
	"retired"
]), d = s.discriminatedUnion("mode", [s.strictObject({
	mode: s.literal("fixed"),
	priority: i
}), s.strictObject({
	mode: s.literal("payload"),
	field: c(200).nullable(),
	defaultPriority: i
})]), f = {
	name: c(100),
	teamId: n.nullable(),
	defaultCustomerId: n.nullable(),
	priorityPolicy: d
}, p = s.strictObject({
	...f,
	provider: l,
	teamId: n.nullable().optional(),
	defaultCustomerId: n.nullable().optional()
}), m = s.strictObject({
	...f,
	expectedVersion: o
}), h = s.strictObject({ expectedVersion: o }), g = h.extend({ confirmed: s.literal(!0) }), _ = s.strictObject({ integrationId: n }), v = s.strictObject({
	teamId: n.optional(),
	cursor: e.optional(),
	limit: t,
	search: s.string().trim().max(100).refine((e) => e.isWellFormed() && !e.includes("\0")).optional(),
	includeRetired: s.union([s.boolean(), s.enum(["true", "false"]).transform((e) => e === "true")]).optional()
}), y = s.enum([
	"created",
	"retry",
	"grouped",
	"ignored",
	"refused",
	"unavailable"
]), b = s.strictObject({
	receivedAt: r,
	outcome: y,
	incidentId: n.nullable()
}), x = s.strictObject({
	id: n,
	name: c(100)
}), S = c(32).min(1).nullable(), C = s.strictObject({
	id: n,
	name: f.name,
	provider: l,
	state: u,
	version: o,
	team: x.nullable(),
	defaultCustomer: x.nullable(),
	credentialLabel: S,
	priorityPolicy: d,
	readiness: s.enum([
		"ready",
		"not-ready",
		"unavailable"
	]),
	lastMessage: b.nullable()
}), w = C.extend({
	teamId: n.nullable(),
	defaultCustomerId: n.nullable(),
	priorityPolicy: d,
	endpoint: s.string().url().max(2e3).refine((e) => {
		if (!URL.canParse(e)) return !1;
		let t = new URL(e);
		return ["http:", "https:"].includes(t.protocol) && !t.username && !t.password && !t.search && !t.hash;
	}, "Endpoint must be HTTP(S) without credentials, query or fragment."),
	readinessReasons: s.array(s.enum([
		"TEAM_REQUIRED",
		"TEAM_INACTIVE",
		"PRIORITY_FIELD_REQUIRED",
		"RETIRED",
		"DEPENDENCY_UNAVAILABLE"
	])).max(5),
	readinessActions: s.array(s.enum([
		"select_team",
		"select_priority_field",
		"check_again"
	])).max(3),
	recentIncidents: s.array(a).max(5).refine((e) => new Set(e.map((e) => e.id)).size === e.length, "Recent incidents must be distinct.")
}), T = s.strictObject({
	items: s.array(C).max(100),
	nextCursor: e.nullable()
}), E = s.strictObject({
	id: n,
	name: f.name,
	provider: l,
	state: u,
	teamId: n.nullable(),
	defaultCustomerId: n.nullable(),
	priorityPolicy: d,
	credentialLabel: S,
	version: o,
	endpoint: w.shape.endpoint
}), D = s.strictObject({
	integration: E,
	credential: s.string().regex(/^[A-Za-z0-9_-]{43}$/).optional()
}), O = s.enum([
	"INVALID_REQUEST",
	"SESSION_REQUIRED",
	"CAPABILITY_DENIED",
	"NOT_FOUND",
	"VERSION_CONFLICT",
	"IDEMPOTENCY_CONFLICT",
	"TEAM_INACTIVE",
	"CUSTOMER_ARCHIVED",
	"PRIORITY_FIELD_REQUIRED",
	"INTEGRATION_RETIRED",
	"INTEGRATION_NOT_RETIRED",
	"PAYLOAD_TOO_LARGE",
	"RATE_LIMITED",
	"STORAGE_UNAVAILABLE",
	"INTERNAL_ERROR"
]), k = s.strictObject({
	code: O,
	message: s.enum(["Monitoring integration request could not be completed."]),
	correlationId: n
}), A = s.discriminatedUnion("outcome", [s.strictObject({
	outcome: s.enum([
		"created",
		"retry",
		"grouped"
	]),
	incident: s.strictObject({
		id: n,
		status: s.enum([
			"open",
			"acknowledged",
			"resolved"
		])
	})
}), s.strictObject({
	outcome: s.literal("ignored"),
	reason: s.enum([
		"recovery",
		"control",
		"non_alert"
	])
})]), j = s.strictObject({
	outcomes: s.array(A).min(1).max(100),
	correlationId: n
}), M = s.enum([
	"AUTHORITY_INVALID",
	"NOT_READY",
	"INVALID_REQUEST",
	"PAYLOAD_TOO_LARGE",
	"RATE_LIMITED",
	"STORAGE_UNAVAILABLE",
	"INTERNAL_ERROR"
]), N = s.strictObject({
	code: M,
	message: s.literal("Monitoring webhook request could not be completed."),
	correlationId: n
}), P = s.strictObject({
	provider: l,
	profileVersion: c(100),
	verification: s.literal("unverified"),
	limitations: c(4e3),
	endpoint: w.shape.endpoint,
	format: s.enum(["json", "form"]),
	headers: s.array(s.strictObject({
		name: c(100),
		value: c(1e3)
	})).max(5),
	template: c(2e4),
	parameters: s.array(s.strictObject({
		name: c(200),
		meaning: c(2e3)
	})).max(40)
}), F = s.strictObject({
	id: n,
	deleted: s.literal(!0)
});
export { y as monitoringDeliveryOutcomeSchema, D as monitoringIntegrationCommandResultSchema, p as monitoringIntegrationCreateSchema, F as monitoringIntegrationDeleteResultSchema, w as monitoringIntegrationDetailSchema, v as monitoringIntegrationListQuerySchema, T as monitoringIntegrationPageSchema, _ as monitoringIntegrationPathSchema, g as monitoringIntegrationRetireSchema, E as monitoringIntegrationSettingsSchema, u as monitoringIntegrationStateSchema, C as monitoringIntegrationSummarySchema, m as monitoringIntegrationUpdateSchema, h as monitoringIntegrationVersionCommandSchema, b as monitoringLastMessageSchema, O as monitoringManagementErrorCodeSchema, k as monitoringManagementErrorSchema, d as monitoringPriorityPolicySchema, P as monitoringProviderConfigurationSchema, l as monitoringProviderSchema, M as monitoringWebhookErrorCodeSchema, N as monitoringWebhookErrorSchema, A as monitoringWebhookOutcomeSchema, j as monitoringWebhookResponseSchema };

//# sourceMappingURL=webhooks.schema.js.map